import { defineComponent as s, renderSlot as r, createBlock as a, openBlock as n, unref as e, withCtx as i } from "vue";
import { useNavState as p } from "../../hooks/useNavState.js";
import m from "../Lazy/Lazy.vue2.js";
const y = /* @__PURE__ */ s({
  __name: "IntroductionSection",
  props: {
    showEmptyState: { type: Boolean }
  },
  setup(c) {
    const { hash: o } = p();
    return (t, d) => t.showEmptyState ? r(t.$slots, "empty-state", { key: 0 }) : (n(), a(e(m), {
      key: 1,
      id: "introduction-card",
      prev: "",
      isLazy: !!e(o) && !e(o).startsWith("description")
    }, {
      default: i(() => [
        r(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["isLazy"]));
  }
});
export {
  y as default
};
